import moment from "moment";
import "moment/locale/id";
import { convertStatus } from "./convertStatusGadai";

export const convertPaymentType = (type) => {
  let converted = "";
  if (type === "balloon_payment") {
    converted = "Ballon Payment";
  } else if (type === "installment") {
    converted = "Installment";
  }
  return converted;
};

export const convertLoanHistory = (data) => {
  let converted = [];

  if (!data) return [];

  data.forEach((item, index) => {
    converted.push({
      key: index + 1,
      id: item.id,
      dateTime: moment(item.gadai_at).format("DD/MM/YYYY"),
      sbg: item.sbg_code || "-",
      paymentType: convertPaymentType(item.payment_type),
      gadaiItem: item.product_details,
      loanValue: item.loan_amount,
      loanMethod: item.loan_method,
      status: {
        label: convertStatus(item.status).label,
        color: convertStatus(item.status).color,
      },
    });
  });
  return converted;
};
